module.exports = __webpack_public_path__ + "static/media/rsrcmtr_100.7a06f3b5.ico";